module.exports = __webpack_public_path__ + "img/emptyDataImage.573d7e65.png";